<script setup lang="ts">
import { BootstrapIconName } from "@/types/bootstrap-icons.types";
import { computed } from "vue";

type ShareOption = {
  type: string;
  href: string;
  iconName: BootstrapIconName;
  text: string;
};
type Props = {
  buttonId: string;
  iconName: BootstrapIconName;
  buttonText?: string;
  emailSubject: string;
  emailBody: string;
};

const props = defineProps<Props>();

const emit = defineEmits(["share"]);

const { t } = useI18n();

const shareOptions = computed<ShareOption[]>(() => [
  {
    type: "email",
    href: `mailto:?subject=${encodeURIComponent(props.emailSubject)}&body=${encodeURIComponent(props.emailBody)}`,
    iconName: "envelope",
    text: t("collections.links.email"),
  },
]);

const handleShareClick = (type: string) => {
  emit("share", type);
};
</script>

<template>
  <div class="dropdown">
    <IconButton
      :id="buttonId"
      class="btn link-dark collection__action"
      type="button"
      :kind="buttonText ? 'naked' : 'link'"
      size="lg"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      :icon-name="iconName"
    >
      <span v-if="buttonText">{{ buttonText }}</span>
    </IconButton>

    <ul class="dropdown-menu" :aria-labelledby="buttonId">
      <BaseDropdownItem
        v-for="option in shareOptions"
        :key="option.type"
        :href="option.href"
        target="_blank"
        :icon-name="option.iconName"
        @click="handleShareClick(option.type)"
      >
        {{ option.text }}
      </BaseDropdownItem>
    </ul>
  </div>
</template>

<style scoped>
.flex-gap-2 {
  gap: 0.5rem;
}
</style>
